enum AuthErrorsEnum {
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INCORRECT_USER_PASSWORD = 'INCORRECT_USER_PASSWORD',
}

export { AuthErrorsEnum };
